import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CambioPerfilService {
  private datosActualizacionPerfil = new BehaviorSubject<any>(null);
  datosSimulacion = this.datosActualizacionPerfil.asObservable();
  preguntas: any[];
  respuestas: any[];

  actualizarPerfil(data: any) {
    this.datosActualizacionPerfil.next(data);
  }

  get encuesta() {
    if (!this.preguntas?.length || !this.respuestas?.length) return [];

    const mapPreguntas = new Map(this.preguntas.map(p => [p.numeroInterno, p]));

    return this.respuestas.reduce((acc, respuesta) => {
      const pregunta = mapPreguntas.get(respuesta.numeroInternoPregunta);
      if (!pregunta) return acc;

      const alternativa = pregunta.alternativas?.alternativa?.find(
        (alt: any) => alt.identificador === respuesta.identificadorAlternativa
      );

      acc.push({
        enunciado: pregunta.enunciado,
        enunciado_numero_interno: pregunta.numeroInterno,
        enunciado_numero_secuencia: pregunta.numero,
        alternativa_seleccionada: alternativa?.descripcion ?? null,
        identificador_alternativa_seleccionada: String(respuesta.identificadorAlternativa),
        orden_alternativa: alternativa?.orden ?? null,
      });

      return acc;
    }, []);
  }
}
